import { render } from "./PackageType.vue?vue&type=template&id=e52a4782"
import script from "./PackageType.vue?vue&type=script&lang=js"
export * from "./PackageType.vue?vue&type=script&lang=js"

import exportComponent from "F:\\App-themes\\clickon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__